import { useEffect } from 'react';
import { useBrandingStore } from '@/store/branding.store';

/**
 * Syncs the page title from the branding settings.
 *
 * Colours, logos and the favicon used to be applied from here at runtime.
 * They now come from the Dual Layer IT design system (index.css,
 * tailwind.config.ts, public/brand), so an admin setting can no longer paint
 * the app in a colour the design system does not have. The stored settings
 * are left untouched, which keeps the change reversible.
 *
 * Mount this once near the root of your app (outside of Router).
 */
export default function BrandingProvider({ children }: { children: React.ReactNode }) {
  const { appName } = useBrandingStore();

  useEffect(() => {
    document.title = appName;
  }, [appName]);

  return <>{children}</>;
}
